import styled from 'styled-components';
import { iconExternal, regularWhite } from 'app/ui-components/design-tokens';
import { playFocus, VisuallyHidden } from 'app/ui-components/utils.styles';
import { playFontIcon } from 'app/ui-components/typography/helpers';

export const StyledExternalIcon = styled.span`
    &:before {
        ${playFontIcon(1.2)}
        font-size: 1.2em;
        margin-right: 0.2em;
        content: '${iconExternal}';
    }
`;

export const StyledExternalLink = styled.a`
    color: ${regularWhite};
    text-decoration: none;
    ${playFocus()};
    display: flex;
`;

export const HiddenA11yText = styled.span`
    ${VisuallyHidden}
`;

export const ExternalText = styled.span`
    text-decoration: underline;
`;
